export const STAGES = [
  "new_query",
  "contacted",
  "quotation_required",
  "quotation_sent",
  "sample_required",
  "sample_sent",
  "follow_up_due",
  "critical",
  "won",
  "lost",
];

export const STAGE_META = {
  new_query: { label: "New Query", cat: "pending" },
  contacted: { label: "Contacted", cat: "pending" },
  quotation_required: { label: "Quotation Required", cat: "pending" },
  quotation_sent: { label: "Quotation Sent", cat: "in_transit" },
  sample_required: { label: "Sample Required", cat: "pending" },
  sample_sent: { label: "Sample Sent", cat: "in_transit" },
  follow_up_due: { label: "Follow-up Due", cat: "pending" },
  critical: { label: "Critical Leads", cat: "urgent" },
  won: { label: "Won", cat: "won" },
  lost: { label: "Lost", cat: "lost" },
};

export const CAT_BADGE = {
  pending: "bg-amber-100 text-amber-800 border border-amber-200",
  in_transit: "bg-blue-100 text-blue-800 border border-blue-200",
  won: "bg-green-100 text-green-800 border border-green-200",
  lost: "bg-slate-200 text-slate-700 border border-slate-300",
  urgent: "bg-red-100 text-red-800 border border-red-200",
};

export const CAT_DOT = {
  pending: "bg-amber-500",
  in_transit: "bg-blue-500",
  won: "bg-green-500",
  lost: "bg-slate-400",
  urgent: "bg-red-500",
};

export const SOURCE_META = {
  website: { label: "Website", icon: "Globe", color: "text-sky-600 bg-sky-50" },
  indiamart: { label: "IndiaMART", icon: "Store", color: "text-orange-600 bg-orange-50" },
  whatsapp: { label: "WhatsApp", icon: "MessageCircle", color: "text-green-600 bg-green-50" },
  calls: { label: "Calls", icon: "Phone", color: "text-violet-600 bg-violet-50" },
  cold: { label: "Cold Outreach", icon: "Snowflake", color: "text-slate-600 bg-slate-100" },
  other: { label: "Other", icon: "MoreHorizontal", color: "text-slate-600 bg-slate-100" },
};

export const SOURCES = Object.keys(SOURCE_META);

// Display the actual source: for "other", show the custom typed detail when present.
export function sourceLabel(lead) {
  if (!lead) return "";
  if (lead.source === "other" && lead.source_detail) return lead.source_detail;
  return SOURCE_META[lead.source]?.label || lead.source || "";
}

export const DIAMETERS = ["D16", "D19", "D22", "D25", "D30", "D35", "D40", "D45", "D50"];

export const TUBE_TYPES = ["PBL", "ABL"];

export const PRIORITY_META = {
  high: { label: "High", color: "bg-red-100 text-red-700 border border-red-200" },
  medium: { label: "Medium", color: "bg-amber-100 text-amber-700 border border-amber-200" },
  low: { label: "Low", color: "bg-slate-100 text-slate-600 border border-slate-200" },
};

export function stageLabel(s) {
  return STAGE_META[s]?.label || s;
}
export function stageCat(s) {
  return STAGE_META[s]?.cat || "pending";
}
